import { Suspense, useState } from "react";
import { Mail } from "lucide-react";
import { Button } from "@/components/ui/button";
import { lazyWithRetry } from "@/lib/lazyWithRetry";
import { LoadingSpinner } from "@/components/LoadingSpinner";

const NewsletterDialog = lazyWithRetry(() => import("./NewsletterDialog").then(m => ({ default: m.NewsletterDialog })));

export function DeferredNewsletterDialog({ cities, userName }: { cities: string[]; userName: string }) {
  const [open, setOpen] = useState(false);
  const [mounted, setMounted] = useState(false);
  return <>
    <Button id="btn-newsletter-open" className="gap-2 tour-newsletter-btn" onClick={() => { setMounted(true); setOpen(true); }}>
      <Mail className="h-4 w-4" />Napi ebédértesítő kérése
    </Button>
    {mounted && <Suspense fallback={open ? <LoadingSpinner /> : null}>
      <NewsletterDialog cities={cities} userName={userName} open={open} onOpenChange={setOpen} />
    </Suspense>}
  </>;
}